// export const domain = 'http://localhost:8000/';
// export const domain = 'https://ec-service.kisrasprint.com';
//production
export const domain = 'https://service.irbrta-research.com/';
